/* Lightbox for the store photo grid on the Amsterdam store page.
   Uses the native <dialog> element. Without JS (or without <dialog>) the thumbnails are plain links to the large photo. */
(function () {
  if (typeof HTMLDialogElement === 'undefined') return;

  document.querySelectorAll('[data-ams-gallery]').forEach(function (gallery) {
    if (gallery.dataset.amsReady) return;
    gallery.dataset.amsReady = 'true';

    var links = Array.prototype.slice.call(gallery.querySelectorAll('[data-ams-photo]'));
    var dialog = gallery.querySelector('[data-ams-lightbox]');
    if (!links.length || !dialog) return;

    var figure = dialog.querySelector('[data-ams-figure]');
    var caption = dialog.querySelector('[data-ams-caption]');
    var counterTemplate = dialog.getAttribute('data-counter') || '';
    var img = document.createElement('img');
    img.className = 'ams-lightbox__img';
    figure.insertBefore(img, caption);

    var current = 0;

    function show(index) {
      current = (index + links.length) % links.length;
      var thumb = links[current].querySelector('img');
      img.classList.remove('is-loaded');
      img.src = links[current].href;
      img.alt = thumb ? thumb.alt : '';
      caption.textContent = counterTemplate
        .replace('__CURRENT__', current + 1)
        .replace('__TOTAL__', links.length);

      // Warm the cache for the neighbours so the arrows feel instant
      [current - 1, current + 1].forEach(function (n) {
        var preload = new Image();
        preload.src = links[(n + links.length) % links.length].href;
      });
    }

    img.addEventListener('load', function () {
      img.classList.add('is-loaded');
    });

    links.forEach(function (link, index) {
      link.addEventListener('click', function (event) {
        // Keep "open in new tab" and friends working
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;
        event.preventDefault();
        show(index);
        dialog.showModal();
        document.documentElement.classList.add('ams-lightbox-open');
      });
    });

    dialog.querySelector('[data-ams-close]').addEventListener('click', function () {
      dialog.close();
    });
    dialog.querySelector('[data-ams-prev]').addEventListener('click', function () {
      show(current - 1);
    });
    dialog.querySelector('[data-ams-next]').addEventListener('click', function () {
      show(current + 1);
    });

    // Click on the dark backdrop (outside the photo and buttons) closes the viewer
    dialog.addEventListener('click', function (event) {
      if (event.target === dialog || event.target === figure) dialog.close();
    });

    dialog.addEventListener('close', function () {
      document.documentElement.classList.remove('ams-lightbox-open');
      img.removeAttribute('src');
    });

    dialog.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        show(current - 1);
      } else if (event.key === 'ArrowRight') {
        event.preventDefault();
        show(current + 1);
      }
    });

    // Swipe left / right on touch screens
    var touchStartX = null;
    dialog.addEventListener('touchstart', function (event) {
      touchStartX = event.changedTouches[0].clientX;
    }, { passive: true });
    dialog.addEventListener('touchend', function (event) {
      if (touchStartX === null) return;
      var dx = event.changedTouches[0].clientX - touchStartX;
      touchStartX = null;
      if (Math.abs(dx) > 50) show(current + (dx < 0 ? 1 : -1));
    }, { passive: true });
  });
})();
